import React from 'react'
import SideBar from '../../components/commoncomponents/SideBar'
import Header from '../../components/commoncomponents/Header'
import Footer from '../../components/commoncomponents/Footer'
import { Layout, Content, ContentBody } from '../../assets/styled-components/layout'
import CreateHospitalInformation from '../../components/hospitalinformationcomponents/CreateHospitalInformation'

function HospitalInformationRegister({renderPageContent}) {
    return (
        <>
                        {/*Dynamic content goes here */}
                        <CreateHospitalInformation renderPageContent={renderPageContent}/>
               

        </>
    )
}

export default HospitalInformationRegister;